<template>
  <textarea :value="value" id="e-textarea" :rows="rows" @input="updateValue($event.target.value)"></textarea>
</template>
<script>
export default {
  name: 'K2Textarea',
  props: ['value', 'rows'],
  data: function () {
    return {
      content: this.value,
    }
  },
  methods: {
    updateValue: function (value) {
      this.$emit('input', value)
    },
  },
}
</script>
<style>
textarea {
  width: 100%;
  border-color: #dcdfe6;
  padding: 5px 10px;
  border-radius: 3px;
  color: #536170;
  height: 100%;
}
</style>
